/**
 * Componente principal de la aplicación que gestiona el enrutamiento y el estado global inicial.
 * Define las rutas públicas y protegidas según los roles de usuario.
 */

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

// Importación de componentes compartidos
import SplashScreen from './shared/components/SplashScreen';
import ProtectedRoute from './shared/components/ProtectedRoute';
import Chatbot from './shared/components/Chatbot/Chatbot';

// Importación de vistas y módulos
import Dashboardmain from './modules/dashboard/Dashboardmain';
import Login from './shared/components/Login';
import About from './shared/components/About';
import Dashboardadmin from './modules/dashboard/Dashboardadmin';
import DashboardIndicators from './modules/indicadores/DashboardIndicators';
import DashboardLab from './modules/dashboard/DashboardLab';
import DashboardConsult from './modules/dashboard/DashboardConsult';
import DashboardWeather from './modules/ambientales/DashboardWeather';
import MapPage from './modules/ubicacion/MapPage';
import New from './shared/components/New';
import Edit from './shared/components/Edit';
import AdminCases from './modules/dashboard/AdminCases';
import AdminPatients from './modules/dashboard/AdminPatients';
import DashboardInvestigador from './modules/dashboard/DashboardInvestigador';
import AdminAccessRequests from './modules/dashboard/AdminAccessRequests';
import AdminNotificationsPage from './modules/dashboard/AdminNotificationsPage';
import DashboardCambiarPassword from './modules/dashboard/DashboardCambiarPassword';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulamos un tiempo de carga para la pantalla de bienvenida (Splash Screen)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000); // 5 segundos

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <SplashScreen />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rutas Públicas: Accesibles por cualquier usuario */}
          <Route path="/" element={<Dashboardmain />} />
          <Route path="/quienes-somos" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/indicadores" element={<DashboardIndicators />} />
          <Route path="/consultar" element={<DashboardConsult />} />
          <Route path="/ambiental" element={<DashboardWeather />} />
          <Route path="/mapa" element={<MapPage />} />

          {/* Rutas Protegidas para Administradores (Global, Lab, Investigación) */}
          <Route path="/DashboardAdmin" element={
            <ProtectedRoute allowedRoles={['admin', 'admin_lab', 'admin_investigacion']}>
              <Dashboardadmin />
            </ProtectedRoute>
          } />

          <Route path="/New" element={
            <ProtectedRoute allowedRoles={['admin', 'admin_lab', 'admin_investigacion']}>
              <New />
            </ProtectedRoute>
          } />

          <Route path="/Edit/:id" element={
            <ProtectedRoute allowedRoles={['admin', 'admin_lab', 'admin_investigacion']}>
              <Edit />
            </ProtectedRoute>
          } />

          <Route path="/AdminCases" element={
            <ProtectedRoute allowedRoles={['admin', 'admin_lab', 'admin_investigacion']}>
              <AdminCases />
            </ProtectedRoute>
          } />

          <Route path="/AdminPatients" element={
            <ProtectedRoute allowedRoles={['admin', 'admin_lab', 'admin_investigacion']}>
              <AdminPatients />
            </ProtectedRoute>
          } />

          <Route path="/AdminAccessRequests" element={
            <ProtectedRoute allowedRoles={['admin', 'admin_lab', 'admin_investigacion']}>
              <AdminAccessRequests />
            </ProtectedRoute>
          } />

          <Route path="/AdminNotifications" element={
            <ProtectedRoute allowedRoles={['admin', 'admin_lab', 'admin_investigacion']}>
              <AdminNotificationsPage />
            </ProtectedRoute>
          } />

          {/* Rutas Protegidas para Laboratorios */}
          <Route path="/GestionLab" element={
            <ProtectedRoute allowedRoles={['admin', 'laboratorio']}>
              <DashboardLab />
            </ProtectedRoute>
          } />

          {/* Rutas Protegidas para Investigadores */}
          <Route path="/DashboardInvestigador" element={
            <ProtectedRoute allowedRoles={['admin', 'investigador']}>
              <DashboardInvestigador />
            </ProtectedRoute>
          } />

          {/* Ruta Protegida para Cambio de Contraseña (Cualquier usuario autenticado) */}
          <Route path="/CambiarPassword" element={
            <ProtectedRoute allowedRoles={['admin', 'admin_lab', 'admin_investigacion', 'laboratorio', 'investigador']}>
              <DashboardCambiarPassword />
            </ProtectedRoute>
          } />

          {/* Ruta por defecto (Redirección al inicio) */}
          <Route path="*" element={<Dashboardmain />} />
        </Routes>
        <Chatbot />
      </div>
    </Router>
  );
}

export default App;
